import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    depId = '',
    userId = '',
    position = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.myOrgDepUser.addUser, {
        depId,
        userId,
        position,
    }, options);
    if (error) return { error, status };
    return content || {};
};
